export default __webpack_public_path__ + "static/media/cv.771a63e8.svg";